(function () {
  "use strict";

  var e = {
    426: function _(e, t) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.Address = void 0;

      t.Address = function (e) {
        e && Object.assign(this, e);
      };
    },
    208: function _(e, t, r) {
      var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
        void 0 === n && (n = r), Object.defineProperty(e, n, {
          enumerable: !0,
          get: function get() {
            return t[r];
          }
        });
      } : function (e, t, r, n) {
        void 0 === n && (n = r), e[n] = t[r];
      }),
          u = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
          i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var r in e) {
          "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
        }
        return u(t, e), t;
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.rpc = t.SwapMode = t.AddressType = void 0;
      var o,
          a,
          s = i(r(329));
      t.rpc = s, (a = t.AddressType || (t.AddressType = {})).LEGACY = "legacy", a.P2SH_SEGWIT = "p2sh-segwit", a.BECH32 = "bech32", (o = t.SwapMode || (t.SwapMode = {})).P2SH = "p2sh", o.P2SH_SEGWIT = "p2shSegwit", o.P2WSH = "p2wsh";
    },
    329: function _(e, t) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
    },
    905: function _(e, t) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
    },
    175: function _(e, t, r) {
      var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
        void 0 === n && (n = r), Object.defineProperty(e, n, {
          enumerable: !0,
          get: function get() {
            return t[r];
          }
        });
      } : function (e, t, r, n) {
        void 0 === n && (n = r), e[n] = t[r];
      }),
          u = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
          i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var r in e) {
          "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
        }
        return u(t, e), t;
      },
          o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.solana = t.terra = t.near = t.ethereum = t.bitcoin = t.Address = t.TxStatus = t.BigNumber = void 0;
      var a = o(r(224));
      t.BigNumber = a.default;
      var s = r(569);
      Object.defineProperty(t, "TxStatus", {
        enumerable: !0,
        get: function get() {
          return s.TxStatus;
        }
      });
      var d = r(426);
      Object.defineProperty(t, "Address", {
        enumerable: !0,
        get: function get() {
          return d.Address;
        }
      });
      var c = i(r(208));
      t.bitcoin = c;
      var l = i(r(905));
      t.ethereum = l;
      var f = i(r(908));
      t.near = f;
      var p = i(r(347));
      t.terra = p;

      var _ = i(r(720));

      t.solana = _;
    },
    908: function _(e, t) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
    },
    720: function _(e, t) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
    },
    347: function _(e, t) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
    },
    569: function _(e, t) {
      var r;
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.TxStatus = void 0, (r = t.TxStatus || (t.TxStatus = {})).Pending = "PENDING", r.Failed = "FAILED", r.Success = "SUCCESS";
    },
    224: function _(e) {
      e.exports = require("bignumber.js");
    }
  },
      t = {},
      r = function r(n) {
    var u = t[n];
    if (void 0 !== u) return u.exports;
    var i = t[n] = {
      exports: {}
    };
    return e[n].call(i.exports, i, i.exports, r), i.exports;
  }(175);

  module.exports = r;
})();